import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL } from "../../config";

/** "This account is blocked. Write to <address>." — nothing else, no reason (PD-0054). */
const AccountBlockedNotice = () => {
  const { t } = useTranslation();
  return (
    <p
      className="mb-4 rounded-lg bg-red-100 p-3 text-sm text-red-800 dark:bg-red-900/30 dark:text-red-300"
      role="alert"
      data-testid="account-blocked-notice"
    >
      {t("auth.accountBlocked", { email: SUPPORT_EMAIL })}
    </p>
  );
};

export default AccountBlockedNotice;
